import { createWebHistory, createRouter, createWebHashHistory } from "vue-router";
import { constantRoutes } from "./routers";

export default createRouter({
  history: createWebHistory(),
  routes: constantRoutes
});